export default "__VITE_ASSET__C0PZue0C__"